import { Link } from "@omni/ui/components/Link/link.component";
import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { pageLink } from "@omni/ui/components/PageLink/pageLink.styles";
import { cn } from "@omni/utils/styles";

const PageLink = ({ link, label, spread = 0 }: PageLinkComponentProps) => {
    return (
        <Link
            data-test={`pageLink-${label}-link`}
            href={link}
            className={pageLink({ spread, className: cn("pl__item") })}
        >
            <div className={cn("pl__listitem")}>{label}</div>
        </Link>
    );
};

export default PageLink;
